import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8 text-center">
        <div className="h-16 w-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto">
          <XCircle className="h-9 w-9 text-amber-600" />
        </div>
        <h1 className="font-display text-xl font-bold mt-4">Pembayaran dibatalkan</h1>
        <p className="text-muted-foreground text-sm mt-2">Tiada bayaran dibuat. Anda boleh cuba lagi bila-bila masa.</p>
        <Button onClick={() => navigate("/app/billing")} data-testid="payment-cancel-back" className="mt-6 rounded-full w-full">
          Kembali ke Langganan
        </Button>
      </div>
    </div>
  );
}
